import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { HeaderSection } from "../HeaderSection";
import { Model } from "../Model";
import { Title } from "../Title";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import styled from "styled-components";
import Calendar from "../../../organisms/Calendar";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalculoPrecioTransporte from "../CalculoPrecioTransporte/CalculoPrecioTransporte";
import { useWizard } from "../../../../hooks/wizard";
import { usePasoReservaGuarderia } from "../pasoReservaGuarderia";
import DatosTransporte from "../DatosTransporte/DatosTransporte";

function FechasTransporte({ model }: { model: Model }) {
  const { currentModel, definirFechasTransporte } =
    usePasoReservaGuarderia(model);
  const { avanza, vuelve, volver, avanzar } = useWizard();
  // Este key sirve para forzar un re-render en el Calendar, ya que el calendario
  // no recibe un arreglo de fechas seleccionadas externamente
  const [calendarKey, setCalendarKey] = useState(0);

  const puedeAvanzar = currentModel.fechasTransporte.length > 0;

  const onDateClick = (date: Date) => {
    let fechas = currentModel.fechasTransporte;
    const exists = fechas.some((f) => f.getTime() === date.getTime());

    let fechasActualizadas: Date[] = [];

    if (exists) {
      fechasActualizadas = fechas.filter((f) => f.getTime() !== date.getTime());
    } else {
      fechasActualizadas = [...fechas, date];
    }

    definirFechasTransporte({ fechas: fechasActualizadas });
  };

  const onSeleccionarTodos = () => {
    definirFechasTransporte({ fechas: model.fechasProgramadas });
    // Forzar re-render
    setCalendarKey(currKey => currKey + 1);
  }

  if (avanza) {
    if (currentModel.contrataTransporte) {
      return <CalculoPrecioTransporte model={currentModel} />;
    }
  }

  if (vuelve) {
    return <DatosTransporte model={currentModel} />;
  }

  return (
    <Row className="justify-content-center">
      <Col className="col-10">
        <HeaderSection className="pt-5 pb-4">
          <Title>
            Fechas de transporte
            <IconContainer>
              <CalendarMonthIcon sx={{ fontSize: 28 }} />
            </IconContainer>
          </Title>
        </HeaderSection>
        <div className="mb-3 d-flex justify-content-between">
          <label className="mb-2">Elija fechas de transporte:</label> 
          <Button size="sm" onClick={onSeleccionarTodos}>Seleccionar todas</Button>
        </div>
        <Row className="mb-3">
          <Col className="col-12" style={{ paddingRight: "0" }}>
            <StyledCalendar
              key={calendarKey}
              onDateClick={onDateClick}
              enabledDates={currentModel.fechasProgramadas}
              preSelectedDates={currentModel.fechasTransporte}
            />
          </Col>
        </Row>

        <Row className="mb-2 justify-content-between">
          <Button
            type={"button"}
            style={{ width: "fit-content" }}
            disabled={!puedeAvanzar}
            onClick={volver}
          >
            <ArrowBackIcon sx={{ fontSize: 20 }} />
            Volver
          </Button>
          <Button
            type={"button"}
            style={{ width: "fit-content" }}
            disabled={!puedeAvanzar}
            onClick={avanzar}
          >
            Siguiente <ArrowForwardIcon sx={{ fontSize: 20 }} />
          </Button>
        </Row>
      </Col>
    </Row>
  );
}

const IconContainer = styled("span")`
  display: relative;
  margin-left: 8px;
  color: ${(props) => props.theme.colors.main};
`;

const StyledCalendar = styled(Calendar)`
  width: 100%;
  border-radius: 5px;
  padding: 0%;
`;

export default FechasTransporte;
